import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import WebhookTester from "@/pages/WebhookTester";
import Base64Tool from "@/pages/Base64Tool";
import IPCalculator from "@/pages/IPCalculator";
import APIFormatter from "@/pages/APIFormatter";
import TimestampConverter from "@/pages/TimestampConverter";
import SSLInspector from "@/pages/SSLInspector";
import NetworkTools from "@/pages/NetworkTools";
import CronEditor from "@/pages/CronEditor";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/webhook-tester" element={<WebhookTester />} />
          <Route path="/base64" element={<Base64Tool />} />
          <Route path="/ip-calculator" element={<IPCalculator />} />
          <Route path="/api-formatter" element={<APIFormatter />} />
          <Route path="/timestamp" element={<TimestampConverter />} />
          <Route path="/ssl-inspector" element={<SSLInspector />} />
          <Route path="/network-tools" element={<NetworkTools />} />
          <Route path="/cron-editor" element={<CronEditor />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;